/**
 * Given an array of active filters, a filter type, and a filter value, removes
 * the filter with the given type and value from the list of active filters.
 * @param {Array} activeFilters - An array of active filter objects.
 * @param {string} type - The type of filter to remove.
 * @param {string|number} value - The value of the filter to remove.
 * @returns {Array} The modified active filters array.
 */
const removeActiveFilter = (activeFilters, type, value) => activeFilters
  .filter(({
    type: checkType,
    value: checkValue,
  }) => type !== checkType || value !== checkValue);

export default removeActiveFilter;
